import React from 'react';
import { ChevronUp, ChevronDown } from 'react-feather';

/**
 * SortIcon — header sort indicator.
 * Shows a directional chevron for the active sort key, and a muted
 * both-ways glyph for sortable-but-inactive columns.
 */
function SortIcon({ columnKey, sortKey, direction }) {
  const active = sortKey === columnKey;
  if (active) {
    const Icon = direction === 'asc' || direction === 'ascending' ? ChevronUp : ChevronDown;
    return <Icon size={11} color="var(--lodge-onyx-600)" style={{ display: 'inline', marginLeft: 3, verticalAlign: 'middle' }} />;
  }
  return (
    <svg width={11} height={11} viewBox="0 0 24 24" fill="none" stroke="var(--lodge-onyx-300)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline', marginLeft: 3, verticalAlign: 'middle' }}>
      <path d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
    </svg>
  );
}

export default SortIcon;
